// extracted by mini-css-extract-plugin
export default {"compliancePage":"styles_compliancePage__bQ3xO"};